<!--
 * @Description: 广告位管理页面
 * @Author: fengal
 * @Date: 2023-02-09 10:43:52
-->
<template>
  <div class="body">
    <!-- 过滤条件 -->
    <el-row class="bk-search" style="margin: 25px 40px" :gutter="0" type="flex" justify="space-between" align="middle">
      <el-col :span="6" style="text-align: left">
        <span class="search-title">所属地区：</span>
        <el-cascader size="small" v-model="areaOptions" clearable filterable  
          placeholder="请选择所属地区" :options="provinceList" style="width: 180px;" 
          :props="{checkStrictly: true, expandTrigger: 'hover', children: 'subRegionList', label: 'name', value: 'id',}">
        </el-cascader>
      </el-col>
      <el-col :span="6" style="text-align:left">
        <span class="search-title">目标应用：</span>
        <el-select v-model="filterParams.targetApplicationType" placeholder="选择应用" size="small" clearable style="width: 180px;" >
          <el-option v-for="item in AppOptions" :key="item.value" :label="item.label" :value="item.value" />
        </el-select>
      </el-col>
      <el-col :span="6" style="text-align:left; display: flex; align-items: center;">
        <span class="search-title">广告类型：</span>
        <el-checkbox-group v-model="advertType" style="width: 180px;">
          <el-checkbox label="1">本平台</el-checkbox>
          <el-checkbox label="2">机构</el-checkbox>
        </el-checkbox-group>
      </el-col>
      <el-col :span="4" style="text-align:right">
        <el-button size="small" type="primary" icon="el-icon-search" @click="handleQuery">搜 索</el-button>
        <el-button v-if="dataPvgList.includes('ADVT_1_CREATE')" size="small" type="primary" icon="el-icon-plus" @click="handleAddAdvert">添 加</el-button>
      </el-col>
    </el-row>
    <div class="main-line"></div>

    <!-- 列表 -->
    <el-table :data="advertList" :header-cell-style="{'background-color':'#EFF5FA'}"
      style="margin: 20px 40px; border: 1px solid #f0f0f0;" :style="tableWidth">
      <el-table-column prop="type" label="广告类型" min-width="8%">
        <template slot-scope="scope">
          <span v-if="scope.row.type === 1">本平台</span>
          <span v-if="scope.row.type === 2">机构</span>
        </template>
      </el-table-column>
      <el-table-column prop="title" label="名称" min-width="9%"></el-table-column>
      <el-table-column prop="city" label="所属地区" min-width="12%">
        <template slot-scope="scope">
          <span v-if="scope.row.province || scope.row.city">{{scope.row.province}}/{{scope.row.city}}</span>
          <span v-else>- -</span>
        </template>
      </el-table-column>
      <el-table-column prop="institutionName" label="专属机构" min-width="12%">
        <template slot-scope="scope">{{scope.row.institutionName ? scope.row.institutionName : '- -'}}</template>
      </el-table-column>
      <el-table-column prop="targetApplicationText" label="目标应用" min-width="8%"></el-table-column>
      <el-table-column prop="positionText" label="展示位置" min-width="10%"></el-table-column>
      <el-table-column prop="status" label="启用状态" min-width="7%">
        <template slot-scope="scope">
          <el-switch v-model="scope.row.status" active-color="#13ce66" :active-value="1" 
            :disabled="!dataPvgList.includes('ADVT_4_STATUS_CHG')" 
            :inactive-value="0" @change="handleStatusChange(scope.row)">
					</el-switch>
        </template>
      </el-table-column>
      <el-table-column prop="creater" label="创建人" min-width="10%">
        <template slot-scope="scope">{{scope.row.creater ? scope.row.creater : '- -'}}</template>
      </el-table-column>
      <el-table-column prop="genTime" label="创建时间" min-width="14%"></el-table-column>
      <el-table-column prop="option" label="操作" min-width="10%">
        <template slot-scope="scope">
          <el-button v-if="dataPvgList.includes('ADVT_2_UPDATE')" @click="handleOperation(scope.row, scope.$index)" type="text" size="small">编辑</el-button>
          <el-divider direction="vertical"></el-divider>
          <el-button v-if="dataPvgList.includes('ADVT_3_DELETE')" @click="handleDeleteClick(scope.row, scope.$index)" type="text" size="small">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-row class="foot-line">
      <el-pagination background @size-change="handlePageSize" @current-change="handleCurPage" 
        :current-page="filterParams.page" :page-sizes="pageSizes" :page-size="filterParams.pageSize" 
        layout="total,prev, pager, next,sizes, jumper" :total="totalNumber" />
    </el-row>
    <!-- 广告位对话框 -->
		<advert-cfg-form :visible="showDialog" :operate="operate" :advertId="advertId" @close-dialog="closeDialog" />
  </div>
</template>

<script>
import Constant from '@/global/Constant.js'
import AdvertCfgForm from './components/AdvertCfgForm.vue'

export default {
  name: 'AdvertCfgList',
  components:{
		'advert-cfg-form':AdvertCfgForm
  },

  data() {
    return {
      dataPvgList: [],//在角色配置页面上的操作权限    

      // 以下是过滤查询相关变量 
      AppOptions: [],
      provinceList: [],
      advertType: [],
      areaOptions: [],
      
      filterParams: {
        targetApplicationType: '',

        page: 1,
        pageSize: this.commonConst.PAGE_SIZE
      },
      pageSizes: [10, 20, 30],
      totalNumber: 0,

      advertList: [],

      showDialog: false,
      operate: 'add',
      advertId: ''
    }
  },

  computed: {
    tableWidth() {
      return 'width:' + (this.$root.contentWidth - 80) + 'px';
    },
  },
  
  methods: {
    async listApps() {
      await this.appAxios("GET", Constant.URL_GET_ADVERT_FILTER_DO).then(result => {
        if (result != null) {
          this.provinceList = result.data.provinceList || [];
          console.log(result.data.targetApplicationTypeMap)
          let appObj = result.data.targetApplicationTypeMap
          for (let app in appObj) {
            this.AppOptions.push({
              value: app,
              label: appObj[app]
            });
          }
        }
      })
    },

    async pageAdvert() {
      await this.getDataPvg4CurRole();
      let header = this.encryptionUtil.signatureParams(this.filterParams,
        Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
      let requestData = {
        method: 'GET',
        url: Constant.URL_LIST_ADVERT,
        param: this.filterParams,
        header: header,
        contentType: this.commonConst.CNTYPE_URLENCODED,
      };
      this.vueRequest(requestData).then((result) => {
          if (result != null) {
            this.advertList = result.data;
            this.totalNumber = result.totalNumber;
          }
      });
    },

    getDataPvg4CurRole() {
      return new Promise((resolve) => {
        let requestData = {
          method: 'GET',
          url: this.commonUrl.URL_GET_DATA_PVG_4_CURROLE,
          param: {entityKey: 'ADVT'},
        };
        this.vueRequest(requestData).then(result => {
          if (result != null) {
            this.dataPvgList = result.data;
            resolve();
          }
        })
      })
    },

    handleStatusChange(row) {
      const status = row.status ? 'enable' : 'disable';
			let params = {
				id: row.id,
				status: status
			};
      let header = this.encryptionUtil.signatureParams(params,
        Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
      let requestData = {
        method: 'PUT',
        url: Constant.URL_UPDATE_ADVERT_STATUS,
        param: params,
        header: header,
        contentType: this.commonConst.CNTYPE_URLENCODED,
      };
			this.vueRequest(requestData).then(result => {
        if (result != null) {
          this.pageAdvert()
        }
      })
    },

    handleOperation(row) {
      this.operate = 'edit'
      this.advertId = row.id
      this.showDialog = true
    },

    handleDeleteClick(row) {
      this.$confirm("确认是否删除名称为【" + row.title + "】的广告?", {
        confirmButtonText: "确 定",
        cancelButtonText: "取 消",
        type: "warning",
      }).then(() => {
        this.deleteAdvertCfg(row.id);
      });
    },

    deleteAdvertCfg(id) {
			let params = {id: id};
      let header = this.encryptionUtil.signatureParams(params,
        Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
      let requestData = {
        method: 'DELETE',
        url: Constant.URL_DELETE_ADVERT,
        param: params,
        header: header,
        contentType: this.commonConst.CNTYPE_URLENCODED,
      };
      this.vueRequest(requestData).then(result => {
				if (result != null) {
          return;
				}
        this.pageAdvert();
			})	  
    },

    closeDialog(flag) {
      if (flag) this.pageAdvert();
      this.showDialog = false
      this.advertId = ''
    },

    handleQuery() {
      if (this.areaOptions.length) {
        this.filterParams.provinceId = this.areaOptions[0]
        this.filterParams.cityId = this.areaOptions[1]
      } else {
        this.filterParams.provinceId = ''
        this.filterParams.cityId = ''
      }
      if(this.advertType.length){
        this.filterParams.advertType = this.advertType.join(",");
      }else {
        delete this.filterParams.advertType;
      }
      this.filterParams.page = 1;
      this.pageAdvert();
    },

    handleAddAdvert() {
      this.operate = 'add'
      this.advertId = ''
      this.showDialog = true
    },

    handlePageSize(val) {
      this.filterParams.pageSize = val;
      this.pageAdvert();
    },

    handleCurPage(curPage) {
      this.filterParams.page = curPage;
      this.pageAdvert();
    },
  },

  mounted() {
    this.$emit("breadcrumb", {text1: '系统配置', text2: '广告位管理'});
    this.listApps().then(_result => {
      this.pageAdvert()
    })
  }
}
</script>

<style scoped>
.body {
  text-align: center;
  border: solid 0px;
}
.main-line {
  height: 10px;
  background-color: #f0f0f0;
}
.search-title {
  color: #657180;
  font-size: 14px;
}
.hr-line {
	height: 10px;
	background-color: #f0f0f0;
}
.foot-line {
  margin-top: 20px;
  text-align: right;
  border: solid 0px;
}
.body >>> .el-checkbox__input.is-checked+.el-checkbox__label {
  color: #606266;
}
</style>


// WEBPACK FOOTER //
// src/components/syscfg/AdvertCfgList.vue